import { render, staticRenderFns } from "./sale_history.vue?vue&type=template&id=dd7ec58a&scoped=true&"
import script from "./sale_history.vue?vue&type=script&lang=js&"
export * from "./sale_history.vue?vue&type=script&lang=js&"
import style0 from "./sale_history.vue?vue&type=style&index=0&id=dd7ec58a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7ec58a",
  null
  
)

export default component.exports